<div class="main-container-left-side">
  <left-sport-menu-desktop></left-sport-menu-desktop>
</div>

<div class="main-container-mid-side">
  <div class="container">
    <div class="header">
      <div class="header-text">
        {{ 'Confirm' | t }}
      </div>
      <div class="arrow-icon down"></div>
    </div>
    <div class="content">
      <div class="message">
        {{ this.mailConfirmMessage }}
      </div>
    </div>
  </div>
</div>
